function stripShopifyAttributes(root) {
  const elements = [root, ...root.querySelectorAll('*')];
  elements.forEach((el) => {
    [...el.attributes].forEach((attr) => {
      if (attr.name.startsWith('data-shopify')) {
        el.removeAttribute(attr.name);
      }
    });
  });
}

function fillMarquee(marquee) {
  const track = marquee.querySelector('[data-marquee-track]');
  const group = marquee.querySelector('[data-marquee-group]');
  if (!track || !group) return;

  const unitWidth = group.getBoundingClientRect().width;
  if (!unitWidth) return;

  track.querySelectorAll('[data-marquee-clone]').forEach((clone) => clone.remove());

  const minWidth = marquee.getBoundingClientRect().width * 2 + unitWidth;
  let safety = 0;
  while (track.getBoundingClientRect().width < minWidth && safety < 100) {
    const clone = group.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    /* `inert` WAS USED HERE AND IT BROKE THE LINKS. 2026-09-09: the client
       reported that "not all the images have working links", and the measurement
       was blunt - 15 of 18 logo links were inside inert clones, leaving 3
       clickable, and at a sampled moment only 2 of the 6 logos actually on
       screen could be clicked. `inert` removes a subtree from the tab order AND
       from hit-testing, and hit-testing is the half we needed to keep: the
       marquee only ever shows one real group, so for most of the scroll cycle
       every visible logo was dead to the pointer.

       The original concern was right and still holds: aria-hidden on FOCUSABLE
       content is a real violation (a keyboard user tabs into a link the screen
       reader has been told does not exist), and focusing an off-screen clone
       makes the browser scroll the overflow:hidden viewport and leave the strip
       offset. Both are solved by taking the clones out of the TAB ORDER only.
       aria-hidden on a non-focusable element is fine, which is what this is - and
       it is the standard duplicate-slide pattern for carousels.

       So: aria-hidden for assistive tech, tabindex="-1" for the keyboard, and
       nothing at all blocking the mouse. Unconditional now, not a fallback. */
    clone.querySelectorAll('a[href], button, input, select, textarea, [tabindex]')
      .forEach(function (el) { el.setAttribute('tabindex', '-1'); });
    clone.setAttribute('data-marquee-clone', '');
    stripShopifyAttributes(clone);
    track.appendChild(clone);
    safety += 1;
  }

  track.style.setProperty('--marquee-distance', `${unitWidth}px`);
}

document.querySelectorAll('[data-marquee]').forEach((marquee) => {
  const run = () => fillMarquee(marquee);

  run();
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(run);
  }

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(run, 200);
  });
});
